import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 6C9569E6-55F1-48AF-A11C-2284315D0CE6
 * name math-norm
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/math-norm.svg
 * tags
 * - Math 
 * - Developer / Languages 
 */
export const MathNormIcon = createSvgIcon(<><path d="M14 21V3H16V21H14M8 21V3H10V21H8Z" /></>, 'MathNormIcon');
export default MathNormIcon